<script setup lang="ts">
const emit = defineEmits(['remove']);
defineProps({
  image: {
    type: String,
  }
})
</script>

<template>
  <div class="text-sm">
    <div class="mt-4 flex flex-row items-center gap-4 md:p-4">
      <div class="w-[32px]">
        <figure class="image w-[32px] h-[32px]">
            <img class="!w-[32px] !h-[32px] rounded-2xl object-cover" :src="image" loading="lazy" />
        </figure>
      </div>
      <div class="flex-1">
        <p class="font-medium text-gray-600 mb-4"><slot name="title" /></p>

        <slot name="content" />
      </div>
      <div>
        <Icon name="charm:cross" size="18" class="cursor-pointer hover:text-rose-400" @click="emit('remove')" />
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>